export const convertSecondsToTimeString = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  let result = '';
  if (hours > 0) {
    result += `${hours}h `;
  }
  if (minutes > 0) {
    result += `${minutes}m`;
  }

  return result.trim();
};

export const convertToSeconds = (timeString) => {
  const timeUnits = timeString.match(/\d+\s*[hm]/g);
  let totalSeconds = 0;

  timeUnits?.forEach((unit) => {
    const number = parseInt(unit, 10);
    const timeUnit = unit.replace(/\d+\s*/g, ''); // Remove digits and spaces to get the unit

    if (timeUnit === 'h') {
      totalSeconds += number * 3600; // 1 hour = 3600 seconds
    } else if (timeUnit === 'm') {
      totalSeconds += number * 60; // 1 minute = 60 seconds
    }
  });

  return totalSeconds;
};
